import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../api/baseQuery";
import type { EhrClinicianDirectory } from "./members.service";
import type { StepKey } from "./onboarding.service";

type InviteResult = { email: string; state: "invited" | "joined" };

export type MyPortalSummary = {
  has_portal: boolean;
  url?: string;
  is_complete?: boolean;
  completed?: number;
  total?: number;
  current_step_key?: StepKey | null;
  current_step_title?: string;
  action_needed?: boolean;
  action_needed_count?: number;
};

/** A logged-in group admin's view of onboarding: their portal summary and the EHR clinician list. */
export const groupOnboardingApi = createApi({
  reducerPath: "groupOnboardingApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["EhrClinicians"],
  endpoints: (builder) => ({
    getMyPortal: builder.query<MyPortalSummary, void>({
      query: () => "/onboarding/my-portal/",
    }),
    getEhrClinicians: builder.query<EhrClinicianDirectory, void>({
      query: () => "/onboarding/group/clinicians/",
      providesTags: ["EhrClinicians"],
    }),
    inviteEhrClinician: builder.mutation<InviteResult, { email: string; name?: string; ehr_provider_id?: string }>({
      query: (body) => ({ url: "/onboarding/group/clinicians/", method: "POST", body }),
      invalidatesTags: ["EhrClinicians"],
    }),
    refreshEhrClinicians: builder.mutation<{ is_pulling: boolean }, void>({
      query: () => ({ url: "/onboarding/group/clinicians/refresh/", method: "POST" }),
      invalidatesTags: ["EhrClinicians"],
    }),
  }),
});

export const {
  useGetMyPortalQuery,
  useGetEhrCliniciansQuery,
  useInviteEhrClinicianMutation,
  useRefreshEhrCliniciansMutation,
} = groupOnboardingApi;
